var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableSortNeutral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.85425 9.875C8.02684 9.875 8.16675 9.73509 8.16675 9.5625V2.19194L10.1333 4.15847C10.2553 4.28051 10.4532 4.28051 10.5752 4.15847C10.6973 4.03643 10.6973 3.83857 10.5752 3.71653L8.07522 1.21653C7.95318 1.09449 7.75532 1.09449 7.63328 1.21653L5.13328 3.71653C5.01124 3.83857 5.01124 4.03643 5.13328 4.15847C5.25532 4.28051 5.45318 4.28051 5.57522 4.15847L7.54175 2.19194V9.5625C7.54175 9.73509 7.68166 9.875 7.85425 9.875Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.47925 1.125C3.65184 1.125 3.79175 1.26491 3.79175 1.4375V8.80806L5.75828 6.84153C5.88032 6.71949 6.07818 6.71949 6.20022 6.84153C6.32226 6.96357 6.32226 7.16143 6.20022 7.28347L3.70022 9.78347C3.57818 9.90551 3.38032 9.90551 3.25828 9.78347L0.758277 7.28347C0.636238 7.16143 0.636238 6.96357 0.758277 6.84153C0.880316 6.71949 1.07818 6.71949 1.20022 6.84153L3.16675 8.80806V1.4375C3.16675 1.26491 3.30666 1.125 3.47925 1.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableSortNeutral);
export default __webpack_public_path__ + "static/media/table_sort_neutral.43390181ffd2b2b2e11f5e81f6395a62.svg";
export { ForwardRef as ReactComponent };